module.exports = __webpack_public_path__ + "img/qrcode.ddc09ea4.jpg";